// Single source of truth for the cookie-consent decision. Bump CONSENT_VERSION
// whenever CONSENT_CATEGORIES changes shape (e.g. a "marketing" category gets
// added later) — a stored record with an older version is treated as "no
// decision yet" so visitors are re-prompted under the new categories instead
// of silently inheriting a decision they never made about the new category.
const STORAGE_KEY = "fh_cookie_consent";
export const CONSENT_VERSION = 2;

export const CONSENT_CATEGORIES = [
  {
    id: "necessary",
    required: true,
    label: "Szükséges",
    description:
      "A weboldal alapműködéséhez szükségesek (pl. a hozzájárulásod rögzítése, a téma megjegyzése). Ezek nélkül a weboldal nem működne megfelelően, ezért nem kapcsolhatók ki.",
  },
  {
    id: "statistics",
    required: false,
    label: "Statisztika",
    description:
      "Anonimizált, összesített látogatottsági adatokat gyűjtenek (Google Analytics), amelyek segítenek megérteni, hogyan használod az oldalt. Nem használjuk hirdetésre vagy személyre szabásra.",
  },
  {
    id: "marketing",
    required: false,
    label: "Marketing",
    description:
      "Hirdetési célú sütik (Google Ads, Meta/Facebook Pixel), amelyek a hirdetéseink célzására, remarketingre és a kampányaink hatékonyságának mérésére szolgálnak.",
  },
];

function defaultCategories() {
  const categories = {};
  CONSENT_CATEGORIES.forEach((category) => {
    categories[category.id] = category.required;
  });
  return categories;
}

function pushConsentUpdate(categories) {
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  gtag("consent", "update", {
    analytics_storage: categories.statistics ? "granted" : "denied",
    ad_storage: categories.marketing ? "granted" : "denied",
    ad_user_data: categories.marketing ? "granted" : "denied",
    ad_personalization: categories.marketing ? "granted" : "denied",
  });
}

export function getConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed.version !== CONSENT_VERSION) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function hasDecided() {
  return getConsent() !== null;
}

// `categories` only needs to carry the non-required ids the caller cares
// about (e.g. { statistics: true }) — required categories are always forced
// to true regardless of what's passed in.
export function saveConsent(categories) {
  const resolved = defaultCategories();
  Object.keys(categories || {}).forEach((id) => {
    if (id in resolved) resolved[id] = Boolean(categories[id]);
  });
  CONSENT_CATEGORIES.forEach((category) => {
    if (category.required) resolved[category.id] = true;
  });

  const record = {
    version: CONSENT_VERSION,
    decidedAt: new Date().toISOString(),
    categories: resolved,
  };

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
  } catch {
    /* localStorage unavailable — consent still applies for this page load
       via pushConsentUpdate below, it just won't be remembered next visit */
  }

  pushConsentUpdate(resolved);
  return record;
}

export function acceptAll() {
  return saveConsent({ statistics: true, marketing: true });
}

export function rejectAll() {
  return saveConsent({ statistics: false, marketing: false });
}
